<template>
  <div class="pr-2">
    <template v-if="db_line_items && db_line_items.length && db_line_items.length > 0">
      <!-- Top Settings Bar -->
      <div
        class="grey lighten-5 custom-grey-border rounded-lg px-3 py-1 my-2 d-flex align-center justify-space-between flex-wrap ga-2">
        <div class="d-flex align-center">
          <v-checkbox v-if="
            !isEnquiry &&
            !isInvoice &&
            !isQuotation &&
            !isPreventive &&
            !isProject &&
            !isOpportunity &&
            !isPurchaseOrder && false
          " readonly class="my-0 py-0" v-model="showPrice" color="cyan" label="Show Price To Engineer"
            hide-details />
        </div>

        <div class="d-flex align-center">
          <label for="discount-level"
            class="caption font-weight-700 text-uppercase grey--text text--darken-2 mr-3 mb-0">
            Discount Level:
          </label>
          <v-radio-group readonly id="discount-level" v-model="discountLevel" row hide-details class="ma-0 pa-0">
            <v-radio label="Line Item" value="line_item" color="cyan"></v-radio>
            <v-radio label="Transaction" value="transaction" color="cyan"></v-radio>
          </v-radio-group>
        </div>
      </div>

      <!-- Responsive Table Container -->
      <div class="line-item-responsive-wrapper overflow-x-auto">
        <div :style="{ minWidth: isPurchaseOrder ? '960px' : '650px' }">
          <!-- Table Header Bar -->
          <div class="grey lighten-4 custom-grey-border rounded-t-lg px-3 py-2 d-flex align-center">
            <div class="color-custom-blue caption-1 font-weight-700 text-center" style="width: 5%">
              #
            </div>
            <div class="color-custom-blue caption-1 font-weight-700 text-left d-flex align-center"
              :style="get_col_style('product')">
              <span>Product / Service / Equipment</span>
              <v-checkbox v-model="is_lump_sum" color="cyan" label="Is Lump Sum" @change="emit_values()" dense
                hide-details class="ml-2 my-0" v-if="isQuotation && is_lump_sum" :disabled="true" />
            </div>
            <div v-if="isPurchaseOrder" class="color-custom-blue caption-1 font-weight-700 text-center"
              style="width: 8%">
              Type
            </div>
            <div v-if="isPurchaseOrder" class="color-custom-blue caption-1 font-weight-700 text-center"
              style="width: 11%">
              Linked Quotation
            </div>
            <div v-if="isPurchaseOrder" class="color-custom-blue caption-1 font-weight-700 text-center"
              style="width: 11%">
              Allocation
            </div>
            <div v-if="!hidePriceForSBU" class="color-custom-blue caption-1 font-weight-700 text-center"
              :style="{ width: isPurchaseOrder ? '10%' : '15%' }">
              Selling/Unit Cost
            </div>
            <div class="color-custom-blue caption-1 font-weight-700 text-center"
              :style="{ width: isPurchaseOrder ? '8%' : '10%' }">
              Quantity/UOM
            </div>
            <div v-if="isPurchaseOrder" class="color-custom-blue caption-1 font-weight-700 text-center"
              style="width: 8%">
              Received Qty
            </div>
            <div v-if="discountLevel == 'line_item' && !hidePriceForSBU"
              class="color-custom-blue caption-1 font-weight-700 text-center"
              :style="{ width: isPurchaseOrder ? '10%' : '15%' }">
              Discount
            </div>
            <div v-if="!hidePriceForSBU" class="color-custom-blue caption-1 font-weight-700 text-right"
              :style="{ width: isPurchaseOrder ? '8%' : '10%' }">
              Total
            </div>
          </div>

          <!-- Line Items List -->
          <div class="custom-grey-border rounded-b-lg border-top-0 overflow-hidden">
            <div v-for="(row, index) in db_line_items" :key="`line-item-drag-${index}`"
              class="px-3 py-1 custom-border-bottom" :class="[
                row.type == 'header'
                  ? 'orange_lighten-5'
                  : index % 2 === 0
                    ? 'white'
                    : 'orange_lighten-5',
                { 'pl-6': row.is_child },
              ]">
              <div :id="`line-item-drag-${index}`" class="d-flex align-center">
                <!-- Index / Sno -->
                <div class="font-weight-700 text-center caption grey--text text--darken-3" style="width: 5%"
                  v-if="row.product_type != 'header'">
                  {{ row.sno }}.
                </div>

                <!-- Section Header Row -->
                <div v-if="row.type == 'header'" class="text-left py-1 width-100">
                  <div class="d-flex align-center">
                    <v-icon color="cyan darken-2" small class="mr-2">mdi-folder-outline</v-icon>
                    <span class="subtitle-2 font-weight-700 color-custom-blue">{{ row.product }}
                    </span>

                    <div class="d-flex align-center ga-1">
                      <v-tooltip top content-class="custom-top-tooltip">
                        <template v-slot:activator="{ on, attrs }">
                          <v-chip v-bind="attrs" v-on="on" color="cyan" text-color="white" x-small label
                            class="font-weight-700 text-uppercase">
                            <template v-if="row.type == 'tools'">T</template>
                            <template v-else-if="row.type == 'parts'">PR</template>
                            <template v-else-if="row.type == 'equipment'">EQP</template>
                            <template v-else>{{
                              row && row.type ? row.type.charAt(0) : ""
                            }}</template>
                          </v-chip>
                        </template>
                        <span class="text-uppercase">
                          <template v-if="row.type == 'tools'">Tools</template>
                          <template v-else-if="row.type == 'equipment'">Equipment</template>
                          <template v-else>{{ row.type }}</template>
                        </span>
                      </v-tooltip>

                      <v-chip v-if="row.barcode" label color="blue darken-4" outlined x-small
                        class="font-weight-700 cursor-pointer ml-1" v-on:click="routeToDetail(row)">
                        {{ row.barcode }}
                      </v-chip>
                      <!-- Serial Numbers: View & Edit if assigned -->
                      <template v-if="
                        row?.serialize_number?.length > 0 &&
                        !isPurchaseOrder &&
                        (row.product_type == 'goods' ||
                          row.product_type == 'parts')
                      ">
                        <v-tooltip top content-class="custom-top-tooltip">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip v-bind="attrs" v-on="on" :color="isPartialSerial(row)
                                ? 'orange darken-2'
                                : 'cyan darken-2'
                              " label x-small v-on:click.stop="optionSerial(row)"
                              class="text-uppercase font-weight-600 white--text cursor-pointer ml-1">
                              <v-icon x-small class="mr-1">mdi-pound</v-icon>
                              <template v-if="isPartialSerial(row)">
                                {{ getAssignedSerialCount(row) }} /
                                {{ row.quantity }} Serials
                              </template>
                              <template v-else>
                                {{ getAssignedSerialCount(row) }} Serials
                              </template>
                            </v-chip>
                          </template>
                          <span class="text-uppercase">
                            View Serial Numbers
                          </span>
                        </v-tooltip>

                        <v-tooltip top content-class="custom-top-tooltip"
                          v-if="relatedType == 3 && canManageSerials && visitStatus != 5">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip v-bind="attrs" v-on="on" color="teal darken-1" label x-small
                              v-on:click.stop="openSerialSelect(row, index)"
                              class="text-uppercase font-weight-600 white--text cursor-pointer ml-1">
                              <v-icon x-small class="mr-1">
                                {{
                                  isPartialSerial(row)
                                    ? "mdi-plus"
                                    : "mdi-pencil"
                                }}
                              </v-icon>
                              {{ isPartialSerial(row) ? "Add More" : "Edit" }}
                            </v-chip>
                          </template>
                          <span class="text-uppercase">
                            {{
                              isPartialSerial(row)
                                ? "Assign More Serial Numbers"
                                : "Change Serial Numbers"
                            }}
                          </span>
                        </v-tooltip>
                      </template>

                      <!-- Serial Numbers: Assign if not yet assigned -->
                      <template v-else-if="
                        isSerializedItem(row) &&
                        relatedType == 3 &&
                        canManageSerials && visitStatus != 5
                      ">
                        <v-tooltip top content-class="custom-top-tooltip">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip v-bind="attrs" v-on="on" color="amber darken-3" label x-small
                              v-on:click.stop="openSerialSelect(row, index)"
                              class="text-uppercase font-weight-600 white--text cursor-pointer ml-1">
                              <v-icon x-small class="mr-1">mdi-plus-circle-outline</v-icon>
                              + Assign Serials (0/{{ row.quantity }})
                            </v-chip>
                          </template>
                          <span class="text-uppercase">
                            Assign Serial Numbers
                          </span>
                        </v-tooltip>
                      </template>
                    </div>
                  </div>

                  <!-- Description -->
                  <div class="caption grey--text text--darken-1 mt-0 text-truncate">
                    <template v-if="row.description">
                      {{ row.description }}
                    </template>
                    <template v-else>
                      <em>No description</em>
                    </template>
                  </div>

                  <!-- Item Images -->
                  <div v-if="row && row.item_images && row.item_images.length" class="d-flex flex-wrap mt-2">
                    <v-img v-for="(nimg, nmlindex) in row.item_images" :key="`new-image-${nmlindex}`" :src="nimg"
                      aspect-ratio="1" height="60" width="60" class="mr-2 mb-1 rounded custom-grey-border">
                      <template v-slot:placeholder>
                        <v-row class="fill-height ma-0" align="center" justify="center">
                          <v-progress-circular indeterminate color="grey darken-2" size="20"></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </div>
                </div>

                <!-- Product Item Row -->
                <div v-else class="text-left d-flex align-center" :style="get_col_style('product', row.is_child)">
                  <div class="d-flex align-center width-100">
                    <v-avatar size="36" class="mr-3 custom-grey-border rounded-pill" v-if="row.product_type != 'other'">
                      <img v-if="row?.image?.url" :src="row?.image?.url" :alt="row?.image?.name" />
                      <img v-else :src="$defaultImage" />
                    </v-avatar>

                    <div class="flex-grow-1 min-width-0">
                      <div class="d-flex align-items-center justify-space-between flex-wrap ga-1">
                        <span class="subtitle-1 font-weight-700 color-custom-blue text-capitalize mr-2">
                          {{ row.product }}
                        </span>

                        <div class="d-flex align-center ga-1">
                          <v-tooltip top content-class="custom-top-tooltip">
                            <template v-slot:activator="{ on, attrs }">
                              <v-chip v-bind="attrs" v-on="on" color="cyan" text-color="white" x-small label
                                class="font-weight-700 text-uppercase">
                                <template v-if="row.type == 'tools'">T</template>
                                <template v-else-if="row.type == 'parts'">PR</template>
                                <template v-else-if="row.type == 'equipment'">EQP</template>
                                <template v-else>{{
                                  row && row.type ? row.type.charAt(0) : ""
                                }}</template>
                              </v-chip>
                            </template>
                            <span class="text-uppercase">
                              <template v-if="row.type == 'tools'">Tools</template>
                              <template v-else-if="row.type == 'equipment'">Equipment</template>
                              <template v-else>{{ row.type }}</template>
                            </span>
                          </v-tooltip>

                          <v-chip v-if="row.barcode" label color="blue darken-4" outlined x-small
                            class="font-weight-700 cursor-pointer ml-1" v-on:click="routeToDetail(row)">
                            {{ row.barcode }}
                          </v-chip>
                          <!-- Serial Numbers: View & Edit if assigned -->
                          <template v-if="
                            row?.serialize_number?.length > 0 &&
                            (row.product_type == 'goods' ||
                              row.product_type == 'parts')
                          ">
                            <v-tooltip top content-class="custom-top-tooltip">
                              <template v-slot:activator="{ on, attrs }">
                                <v-chip v-bind="attrs" v-on="on" :color="isPartialSerial(row)
                                    ? 'orange darken-2'
                                    : 'cyan darken-2'
                                  " label x-small v-on:click.stop="optionSerial(row)"
                                  class="text-uppercase font-weight-600 white--text cursor-pointer ml-1">
                                  <v-icon x-small class="mr-1">mdi-pound</v-icon>
                                  <template v-if="isPartialSerial(row)">
                                    {{ row.serialize_number.length }} /
                                    {{ row.quantity }} Serials
                                  </template>
                                  <template v-else>
                                    {{ row.serialize_number.length }} Serials
                                  </template>
                                </v-chip>
                              </template>
                              <span class="text-uppercase">
                                View Serial Numbers
                              </span>
                            </v-tooltip>

                            <v-tooltip top content-class="custom-top-tooltip"
                              v-if="relatedType == 3 && canManageSerials && visitStatus != 5">
                              <template v-slot:activator="{ on, attrs }">
                                <v-chip v-bind="attrs" v-on="on" color="teal darken-1" label x-small
                                  v-on:click.stop="openSerialSelect(row, index)"
                                  class="text-uppercase font-weight-600 white--text cursor-pointer ml-1">
                                  <v-icon x-small class="mr-1">
                                    {{
                                      isPartialSerial(row)
                                        ? "mdi-plus"
                                        : "mdi-pencil"
                                    }}
                                  </v-icon>
                                  {{
                                    isPartialSerial(row) ? "Add More" : "Edit"
                                  }}
                                </v-chip>
                              </template>
                              <span class="text-uppercase">
                                {{
                                  isPartialSerial(row)
                                    ? "Assign More Serial Numbers"
                                    : "Change Serial Numbers"
                                }}
                              </span>
                            </v-tooltip>
                          </template>

                          <!-- Serial Numbers: Assign if not yet assigned -->
                          <template v-else-if="
                            isSerializedItem(row) &&
                            relatedType == 3 &&
                            canManageSerials && visitStatus != 5
                          ">
                            <v-tooltip top content-class="custom-top-tooltip">
                              <template v-slot:activator="{ on, attrs }">
                                <v-chip v-bind="attrs" v-on="on" color="amber darken-3" label x-small
                                  v-on:click.stop="openSerialSelect(row, index)"
                                  class="text-uppercase font-weight-600 white--text cursor-pointer ml-1">
                                  <v-icon x-small class="mr-1">mdi-plus-circle-outline</v-icon>
                                  + Assign Serials (0/{{ row.quantity }})
                                </v-chip>
                              </template>
                              <span class="text-uppercase">
                                Assign Serial Numbers
                              </span>
                            </v-tooltip>
                          </template>
                        </div>
                      </div>

                      <!-- Description -->
                      <div class="caption grey--text text--darken-1 mt-0 text-truncate">
                        <template v-if="row.description">
                          {{ row.description }}
                        </template>
                        <template v-else>
                          <em>No description</em>
                        </template>
                      </div>

                      <!-- Item Images -->
                      <div v-if="row && row.item_images && row.item_images.length" class="d-flex flex-wrap mt-2">
                        <v-img v-for="(nimg, nmlindex) in row.item_images" :key="`new-image-${nmlindex}`" :src="nimg"
                          aspect-ratio="1" height="60" width="60" class="mr-2 mb-1 rounded custom-grey-border">
                          <template v-slot:placeholder>
                            <v-row class="fill-height ma-0" align="center" justify="center">
                              <v-progress-circular indeterminate color="grey darken-2" size="20"></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Type (PO) -->
                <div v-if="isPurchaseOrder && !(row.type == 'header')" class="text-center px-1" style="width: 8%">
                  <v-chip x-small color="cyan darken-2" outlined class="font-weight-700">
                    {{ row.po_type || "N/A" }}
                  </v-chip>
                </div>

                <!-- Linked Quotation (PO) -->
                <div v-if="isPurchaseOrder && !(row.type == 'header')" class="text-center px-1" style="width: 11%">
                  <v-chip x-small color="cyan darken-2" class="font-weight-600 white--text cursor-pointer"
                    @click.stop="row.linked_quotation && routeToQuotationDetail(row)">
                    <v-icon x-small class="mr-1">mdi-format-quote-close</v-icon>
                    {{ row.linked_quotation || "N/A" }}
                  </v-chip>
                </div>

                <!-- Allocation (PO) -->
                <div v-if="isPurchaseOrder && !(row.type == 'header')" class="text-center px-1" style="width: 11%">
                  <v-chip x-small color="cyan darken-2" class="font-weight-600 white--text cursor-pointer"
                    v-on:click.stop="openAllocationView(row)">
                    <v-icon x-small class="mr-1">mdi-call-split</v-icon>
                    {{ row.allocation_summary || "V001, V002 · 4/4" }}
                  </v-chip>
                </div>

                <!-- Selling / Unit Cost -->
                <div class="text-center font-weight-600 caption-1" :style="{ width: isPurchaseOrder ? '10%' : '15%' }"
                  v-if="!(row.type == 'header') && !hidePriceForSBU">
                  <v-tooltip
                    v-if="isQuotation && Number(row.customer_latest_quoted_rate) > 0"
                    top
                    content-class="custom-top-tooltip"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on" class="cursor-pointer">
                        {{ row.rate }}
                      </span>
                    </template>
                    <div>
                      Latest price :
                      {{ formatMoney(row.customer_latest_quoted_rate || 0) }}
                    </div>
                  </v-tooltip>
                  <template v-else>
                    {{ row.rate }}
                  </template>
                </div>

                <!-- Quantity / UOM -->
                <div class="text-center font-weight-600 caption-1" :style="{ width: isPurchaseOrder ? '8%' : '10%' }"
                  v-if="!(row.type == 'header')">
                  {{ row.quantity }}
                  <span class="grey--text">{{ row.uom }}</span>
                </div>

                <!-- Received Qty (PO) -->
                <div v-if="isPurchaseOrder && !(row.type == 'header')" class="text-center" style="width: 8%">
                  <v-chip small color="green lighten-5" text-color="green darken-3" class="font-weight-700 px-3">
                    <v-icon small left color="green darken-3">mdi-plus</v-icon>
                    {{ row.received_qty || 0 }}
                  </v-chip>
                </div>

                <!-- Discount (Line Item level) -->
                <!-- <div class="text-center" :style="{ width: isPurchaseOrder ? '10%' : '15%' }" v-if="
                  discountLevel == 'line_item' &&
                  !(row.type == 'header') &&
                  !hidePriceForSBU
                ">
                  <div class="d-flex align-center">
                    <v-text-field readonly hide-details dense outlined solo flat type="number"
                      v-model="row.discount_value" color="cyan" class="caption-1 font-weight-600 mr-1"
                      style="width: 50%" />
                    <v-select disabled :items="discount_type_list" v-model="row.discount_type" hide-details
                      item-text="type" item-value="value" dense outlined solo flat color="cyan"
                      class="caption-1 font-weight-600" style="width: 50%" />
                  </div>
                </div> -->
                <div
                  class="text-center"
                  :style="{ width: isPurchaseOrder ? '10%' : '15%' }"
                  v-if="
                    discountLevel == 'line_item' &&
                    !(row.type == 'header') &&
                    !hidePriceForSBU
                  "
                >
                  <span
                    v-if="row.discount_type == 2"
                    class="caption-1 font-weight-600"
                  >
                    ({{ parseFloat(row.discount_value) }} {{ getDiscountType(row.discount_type) }})
                  </span>

                  <span class="caption-1 font-weight-600 ml-1">
                    $ {{ row.discount }}
                  </span>
                </div>

                <!-- Total -->
                <div class="text-right font-weight-700 subtitle-1 color-custom-blue"
                  :style="{ width: isPurchaseOrder ? '8%' : '10%' }" v-if="!(row.type == 'header') && !hidePriceForSBU">
                  {{ row.total }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- Empty State -->
    <template v-else>
      <div class="d-flex flex-column align-center justify-center py-10">
        <v-avatar color="cyan lighten-5" size="64" class="mb-3">
          <v-icon size="36" color="cyan darken-2">mdi-package-variant-closed</v-icon>
        </v-avatar>
        <h3 class="subtitle-1 font-weight-700 color-custom-blue mb-1">
          No Line Items Found
        </h3>
        <p class="caption grey--text text--darken-1 mb-0">
          There are no line items added for this record at the moment.
        </p>
      </div>
    </template>

    <!-- Serial Number Dialog -->
    <ViewSerialNumber v-if="seleceDialog && !isPurchaseOrder" :transaction-detail="transactionDetail"
      :dialogStatus="seleceDialog" :parent-id="relatedId" v-on:close:dialog="seleceDialog = false">
    </ViewSerialNumber>

    <!-- Serial Number Select/Assign Dialog -->
    <SerialNumberSelect v-if="serialSelectDialog" :key="`serial-select-${serialDialogKey}`"
      :transaction-detail="selectedLineItemForSerial" :parent-index="serialParentIndex"
      :dialogStatus="serialSelectDialog" :allow-partial="true" v-on:close:dialog="serialSelectDialog = false"
      v-on:update:item="saveLineItemSerials">
    </SerialNumberSelect>

    <!-- View Allocation Detail Dialog -->
    <ViewAllocationDetail v-if="viewAllocationDialog" :transaction-detail="selectedLineItemForAllocationView"
      :dialogStatus="viewAllocationDialog" v-on:close:dialog="viewAllocationDialog = false">
    </ViewAllocationDetail>
    <POReceivedSerialDialog v-if="poSerialDialog" :dialog-status="poSerialDialog" :purchase-order="relatedId"
      :transaction-detail="poSerialRow" v-on:close:dialog="poSerialDialog = false"></POReceivedSerialDialog>
  </div>
</template>

<script>
import { QUERY, POST } from "@/core/services/store/request.module";
import ViewSerialNumber from "@/view/pages/partials/View-Serial-Number.vue";
import SerialNumberSelect from "@/view/pages/partials/Serial-Number-Select.vue";
import ViewAllocationDetail from "@/view/pages/partials/View-Allocation-Detail.vue";
import POReceivedSerialDialog from "@/view/pages/partials/PO-Received-Serial-Dialog.vue";
import JwtService from "@/core/services/jwt.service";
import CommonMixin from "@/core/plugins/common-mixin";
import { SuccessEventBus } from "@/core/lib/message.lib";

export default {
  name: "visit-line-item",
  mixins: [CommonMixin],
  props: {
    showPrice: {
      type: Boolean,
      default: false,
    },
    discountLevel: {
      type: String,
      default: "transaction",
    },
    visitStatus: {
      type: [Number, String],
      default: 0,
    },
    relatedId: {
      type: Number,
      default: 0,
    },
    isEnquiry: {
      type: Boolean,
      default: false,
    },
    isQuotation: {
      type: Boolean,
      default: false,
    },
    isPreventive: {
      type: Boolean,
      default: false,
    },
    isInvoice: {
      type: Boolean,
      default: false,
    },
    relatedType: {
      type: Number,
      default: 0,
    },
    isProject: {
      type: Boolean,
      default: false,
    },
    isOpportunity: {
      type: Boolean,
      default: false,
    },
    isPurchaseOrder: {
      type: Boolean,
      default: false,
    },
    quotationDetail: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      db_line_items: [],
      discount_type_list: [
        { type: "%", value: "2" },
        { type: "$", value: "1" },
      ],
      sno: 1,
      loading: false,
      transactionDetail: {},
      seleceDialog: false,
      poSerialDialog: false,
      poSerialRow: {},
      is_lump_sum: false,
      currentUser: new Object(),
      serialSelectDialog: false,
      selectedLineItemForSerial: {},
      serialParentIndex: 0,
      serialDialogKey: 0,
      viewAllocationDialog: false,
      selectedLineItemForAllocationView: {},
    };
  },
  methods: {
    openAllocationView(row) {
      this.selectedLineItemForAllocationView = row;
      this.viewAllocationDialog = true;
    },
    getAssignedSerialCount(row) {
      if (!row) return 0;
      if (
        typeof row.assigned_quantity !== "undefined" &&
        row.assigned_quantity !== null
      ) {
        return Number(row.assigned_quantity);
      }
      return Array.isArray(row?.serialize_number)
        ? row.serialize_number.length
        : 0;
    },
    isPartialSerial(row) {
      const serialCount = this.getAssignedSerialCount(row);
      const qty = Number(row?.quantity || 0);
      return serialCount > 0 && serialCount < qty;
    },
    isSerializedItem(row) {
      if (!row) return false;
      const isGoodOrPart =
        row.product_type == "goods" ||
        row.product_type == "parts" ||
        row.type == "product" ||
        row.type == "parts";
      const isSerialized =
        row.isSerialized == 1 ||
        row.serial_number == 1 ||
        (row.main_product &&
          (row.main_product.isSerialized == 1 ||
            row.main_product.trackSerial == 1 ||
            row.main_product.serial_number == 1 ||
            !!row.main_product.serial_prefix)) ||
        (row.serialize_number && row.serialize_number.length > 0);
      return isGoodOrPart && isSerialized;
    },
    openSerialSelect(row, index) {
      this.selectedLineItemForSerial = {
        ...row,
        parent: this.relatedId,
        quantity: Number(row.quantity || 0),
      };
      this.serialParentIndex = index;
      this.serialDialogKey += 1;
      this.serialSelectDialog = true;
    },
    saveLineItemSerials(payload) {
      if (
        !this.selectedLineItemForSerial ||
        !this.selectedLineItemForSerial.id
      ) {
        return;
      }
      this.loading = true;
      this.$store
        .dispatch(POST, {
          url: `visit/${this.relatedId}/line-item/${this.selectedLineItemForSerial.id}/assign-serials`,
          data: {
            serial_numbers: payload.data,
          },
        })
        .then(() => {
          SuccessEventBus.$emit(
            "update:success",
            "Serial Number(s) assigned successfully."
          );
          this.serialSelectDialog = false;
          this.get_line_items();
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    optionSerial(row) {
      this.transactionDetail = {
        ...row,
        parent: this.relatedId,
        visit_id: this.relatedId,
      };
      this.seleceDialog = true;
    },
    routeToQuotationDetail(data) {
      const quotationId = data?.quotation_id || data?.linked_quotation_id || 1;
      this.$router.push(
        this.getDefaultRoute("quotation.detail", {
          params: { id: quotationId },
        })
      );
    },
    getDiscountType(value) {
      const discountType = this.discount_type_list.find(
        item => item.value == value
      );

      return discountType ? discountType.type : '';
    },
    openReceivedSerials(row) {
      if (!this.canViewReceivedSerials(row)) return;
      if (this.isPurchaseOrder) {
        this.poSerialRow = {
          ...row,
          product_type:
            row.main_product?.product_type ||
            row.original_product?.product_type ||
            row.product_type,
        };
        this.poSerialDialog = true;
        return;
      }
      this.optionSerial(row);
    },
    canViewReceivedSerials(row) {
      if (!this.isPurchaseOrder || !row) return false;
      const productType =
        row.main_product?.product_type ||
        row.original_product?.product_type ||
        row.product_type;
      if (!["goods", "parts"].includes(productType)) return false;
      const productId = Number(row.product_id || row.product || 0);
      const isSerialized =
        row?.serialize_number?.length > 0 ||
        Number(
          row.isSerialized ||
          row.is_serialized ||
          row.main_product?.isSerialized
        ) === 1;
      return productId > 0 && isSerialized;
    },
    routeToDetailLink(id, type) {
      this.$router.push({
        name: type,
        params: { id },
      });
    },
    routeToDetail(data) {
      let routeName = null;
      if (data.product_type == "equipment") {
        routeName = "client-equipment.detail";
      } else if (data.product_type == "tools") {
        routeName = "equipment.detail";
      } else if (data.product_type == "asset") {
        routeName = "asset-equipment.detail";
      } else if (data.product_type == "goods") {
        routeName = "product.detail";
      } else if (data.product_type == "service") {
        routeName = "service.detail";
      } else if (data.product_type == "parts") {
        routeName = "part.detail";
      }
      if (data && data.product_id && data.product_id > 0) {
        this.$router.push(
          this.getDefaultRoute(routeName, {
            params: { id: data.product_id },
          })
        );
      }
    },
    initializeLumpSum() {
      this.is_lump_sum = Array.isArray(this.db_line_items)
        ? this.db_line_items.some((item) => Number(item.is_lump_sum) === 1)
        : false;
    },
    get_line_items() {
      this.loading = true;
      const data = {
        type: this.relatedType,
      };
      if (this.isQuotation && this.quotationDetail) {
        if (this.quotationDetail.customer) {
          data.customer =
            typeof this.quotationDetail.customer === "object"
              ? this.quotationDetail.customer.id
              : this.quotationDetail.customer;
        }
        if (this.quotationDetail.sales_id) {
          data.sales_executive = this.quotationDetail.sales_id;
        }
      }
      this.$store
        .dispatch(QUERY, {
          url: `detail-iteam/${this.relatedId}/line-items`,
          data,
        })
        .then(({ data }) => {
          this.db_line_items = data;
          this.$emit("line-item", this.db_line_items.length);
        })
        .catch((error) => {
          console.log({ error });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    get_col_style(param, child) {
      let width = 45;
      if (param === "product") {
        if (!this.showPrice || this.hidePriceForSBU) {
          width = this.isPurchaseOrder ? 55 : 85;
        } else if (this.showPrice) {
          if (this.discountLevel === "transaction") {
            width = this.isPurchaseOrder ? 34 : 60;
          } else {
            width = this.isPurchaseOrder ? 24 : 45;
          }
        }
      }
      return { width: child ? `${width - 3}%` : `${width}%` };
    },
    getUserProfile() {
      const _this = this;
      try {
        _this.currentUser = JwtService.currentUser();
      } catch (error) {
        _this.logError(error);
        _this.onLogout();
      }
    },
  },
  watch: {
    db_line_items: {
      handler() {
        this.initializeLumpSum();
      },
      deep: true,
      immediate: true,
    },
    quotationDetail: {
      handler(newVal, oldVal) {
        const newCust = newVal?.customer?.id || newVal?.customer;
        const oldCust = oldVal?.customer?.id || oldVal?.customer;
        const newSales = newVal?.sales_id;
        const oldSales = oldVal?.sales_id;
        if (
          this.isQuotation &&
          newVal &&
          oldVal &&
          (newCust !== oldCust || newSales !== oldSales)
        ) {
          this.get_line_items();
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.get_line_items();
    this.getUserProfile();
  },
  computed: {
    canManageSerials() {
      return true;
    },
    hidePriceForSBU() {
      if (
        this.currentUser?.role == 1 ||
        this.currentUser?.id == this.quotationDetail?.prepared_by_id ||
        this.currentUser?.id == this.quotationDetail?.added_by ||
        this.currentUser?.id == this.quotationDetail?.sales_id
      ) {
        return false;
      }
      return this.isQuotation && this.currentUser?.is_sbu_head == 1;
    },
    getSN: () => {
      return function (row, index) {
        if (index == 0) {
          this.sno = 1;
        }
        if (row.product_type == "header") {
          this.sno = 1;
        } else {
          this.sno = this.sno + 1;
        }
      };
    },
  },
  components: {
    ViewSerialNumber,
    SerialNumberSelect,
    ViewAllocationDetail,
    POReceivedSerialDialog,
  },
};
</script>
